import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/pension-calculator',
  component: () => import('../../routes/PensionCalculator.svelte'),
  card: {
    id: 'pension-calculator',
    title: 'Pension Calculator',
    description: 'Calculate the lump-sum present value of a pension or the monthly income you could receive from a pension lump sum. Compare payout options with year-by-year breakdowns.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/pension-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Pension Calculator – Lump Sum vs. Monthly Pension Income Calculator',
    description:
      'Free pension calculator to calculate the lump-sum value of a pension income stream or the monthly income from a pension lump sum. Compare payout options with year-by-year breakdowns.',
  },
};

export default meta;
